import React from 'react';
import {
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from '@material-ui/core';

import {
    BUY_X_GET_Y_PRESETS,
    BuyXGetYFormState,
    DEFAULT_BUY_X_GET_Y,
    resolveBuyXGetYCounts,
} from '../lib/koronaPromotionConfig';

interface Props {
    form: BuyXGetYFormState;
    onChange: (form: BuyXGetYFormState) => void;
}

const BuyXGetYForm: React.FC<Props> = ({ form, onChange }) => {
    const { countAmount, discountAmount, triggerQty, discountPercent } = resolveBuyXGetYCounts(form);
    const isFree = discountPercent >= 100;

    const matchingPresetId =
        BUY_X_GET_Y_PRESETS.find(
            (p) =>
                p.state.buyQty === form.buyQty &&
                p.state.getQty === form.getQty &&
                p.state.discountPercent === form.discountPercent
        )?.id || 'custom';

    return (
        <>
            <Typography variant="subtitle2" style={{ marginTop: 8 }}>
                Buy X Get Y
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                Creates an EXTENDED Korona promotion (same shape as B2G1 / B1G20% in Korona Cloud).
            </Typography>
            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel id="bxgy-preset-label">Preset</InputLabel>
                <Select
                    labelId="bxgy-preset-label"
                    label="Preset"
                    value={matchingPresetId}
                    onChange={(e) => {
                        const preset = BUY_X_GET_Y_PRESETS.find((p) => p.id === e.target.value);
                        if (preset) {
                            onChange({ ...preset.state });
                        }
                    }}
                >
                    {BUY_X_GET_Y_PRESETS.map((preset) => (
                        <MenuItem key={preset.id} value={preset.id}>
                            {preset.label}
                        </MenuItem>
                    ))}
                    <MenuItem value="custom">Custom</MenuItem>
                </Select>
            </FormControl>
            <TextField
                label="Buy quantity"
                type="number"
                value={form.buyQty}
                onChange={(e) => onChange({ ...form, buyQty: e.target.value })}
                fullWidth
                margin="dense"
                variant="outlined"
                inputProps={{ min: 1 }}
                helperText="Items the customer must purchase."
            />
            <TextField
                label="Get quantity"
                type="number"
                value={form.getQty}
                onChange={(e) => onChange({ ...form, getQty: e.target.value })}
                fullWidth
                margin="dense"
                variant="outlined"
                inputProps={{ min: 1 }}
                helperText="Items that receive the discount."
            />
            <TextField
                label="Discount (%)"
                type="number"
                value={form.discountPercent}
                onChange={(e) => onChange({ ...form, discountPercent: e.target.value })}
                fullWidth
                margin="dense"
                variant="outlined"
                inputProps={{ min: 0, max: 100, step: 1 }}
                helperText="100 = free item(s). Lower values apply a partial % off (e.g. 20)."
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={form.exclusive}
                        onChange={(e) => onChange({ ...form, exclusive: e.target.checked })}
                        color="primary"
                    />
                }
                label="Exclusive layer"
            />
            <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 8 }}>
                Korona selection: count {countAmount}, discount {discountAmount} @ {discountPercent}%
                {isFree ? ' (free extras)' : ' (partial off)'}; trigger qty ≥ {triggerQty}.
            </Typography>
        </>
    );
};

export { DEFAULT_BUY_X_GET_Y };
export default BuyXGetYForm;
